var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32812 4.7793L6.47852 7.18555C6.47852 7.33594 6.58594 7.42188 6.73633 7.42188H7.61719C7.76758 7.42188 7.875 7.31445 7.875 7.18555L8.02539 4.7793C8.02539 4.62891 7.91797 4.5 7.76758 4.5H6.58594C6.43555 4.5 6.32812 4.62891 6.32812 4.7793ZM8.08984 8.625C8.08984 8.13086 7.68164 7.72266 7.1875 7.72266C6.67188 7.72266 6.28516 8.13086 6.28516 8.625C6.28516 9.14062 6.67188 9.52734 7.1875 9.52734C7.68164 9.52734 8.08984 9.14062 8.08984 8.625ZM8.06836 0.890625C7.68164 0.224609 6.67188 0.203125 6.28516 0.890625L1.12891 9.84961C0.742188 10.5156 1.23633 11.375 2.03125 11.375H12.3223C13.1172 11.375 13.6113 10.5371 13.2246 9.84961L8.06836 0.890625ZM2.13867 10.1719L7.05859 1.62109C7.12305 1.53516 7.23047 1.53516 7.29492 1.62109L12.2148 10.1719C12.2793 10.2578 12.2148 10.3438 12.1074 10.3438H2.24609C2.13867 10.3438 2.07422 10.2578 2.13867 10.1719Z",
    fill: "#D62D0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b3c20e87a666883c4ecbab9022be79a9.svg";
export { ForwardRef as ReactComponent };